import React, { Component } from 'react';
import styled from 'styled-components';

import Color from '../../utils/colors';
import { Font, FontWeight } from '../../utils/fonts';
import mediaWidth from '../../utils/mediaWidth/mediaWidth';
import { getDirectionCheckboxes } from '../../utils/directionsData';

import Analytics from '../../services/Analytics';

import Content from '../../common/Content';
import FilledButton from '../../common/FilledButton';
// import Maze from '../MazeMain';
import FadeInAnimation from '../../common/FadeInAnimation';
import form from '../PopupForm';


class StartScreenMain extends Component {
    constructor() {
        super();
        this.handleClick = this.handleClick.bind(this);
    }

    handleClick() {
        const {
            handleOpenPopUp,
            scrollToForm,
        } = this.props;

        handleOpenPopUp(form, { checkboxes: getDirectionCheckboxes() }, scrollToForm);
        Analytics.sendEvent('go to Form from Main start screen');
    }

    render() {
        // const { className, isMazeAnimate } = this.props;
        const { className } = this.props;

        return (
            <Root className={className}>
                {/* <Maze isMazeAnimate={isMazeAnimate} /> */}
                <ContentStyled>
                    <FadeInAnimation delay="0.7" duration="0.5">
                        <Headline>
                            Создаем решения, которые
                            <Br />
                            {' '}
                            вам близки
                        </Headline>
                    </FadeInAnimation>
                    <FadeInAnimation delay="0.9" duration="0.5">
                        <Text>
                        Мы помогаем клиентам запускать
                            <Br />
                            {' '}
                        и&nbsp;развивать продукты и&nbsp;сервисы
                        </Text>
                    </FadeInAnimation>
                    <FadeInAnimation delay="1" duration="0.5">
                        <Btn
                            onClick={this.handleClick}
                        >
                            Обсудить задачу
                        </Btn>
                    </FadeInAnimation>
                </ContentStyled>
            </Root>
        );
    }
}

const Root = styled.div`
    height: 100vh;
    height: ${window.innerHeight}px;

    display: flex;
    align-items: center;

    background: ${Color.PRIMARY};

    position: relative;
    overflow: hidden;

    ${mediaWidth.l} {
        background: transparent;
    }
`;

const Headline = styled.div`
    ${Font.HEADLINE};
    ${FontWeight.REGULAR};
    font-size: 48px;
    line-height: 48px;

    color: ${Color.TEXT_PRIMARY};
    text-transform: uppercase;

    margin-bottom: 24px;

    ${mediaWidth.m} {
        width: 460px;

        font-size: 56px;
        line-height: 56px;

        margin-bottom: 32px;
    }

    ${mediaWidth.l} {
        font-size: 56px;
        line-height: 56px;

        margin-bottom: 24px;
    }

    ${mediaWidth.xl} {
        width: 733px;

        font-size: 64px;
        line-height: 64px;

        margin-bottom: 40px;
    }
`;

const Text = styled.div`
    ${Font.PRIMARY};
    ${FontWeight.REGULAR};
    font-size: 16px;
    line-height: 24px;
    color: #000000;
    opacity: 0.64;

    margin-bottom: 24px;

    ${mediaWidth.m} {
        width: 435px;

        font-size: 20px;
        line-height: 28px;

        margin-bottom: 32px;
    }

    ${mediaWidth.l} {
        font-size: 20px;
        line-height: 28px;
    }

    ${mediaWidth.xl} {
        width: 623px;

        font-size: 24px;
        line-height: 32px;

        margin-bottom: 40px;
    }
`;

const Btn = styled(FilledButton)`
    width: 328px;
    height: 63px;

    ${mediaWidth.m} {
        width: 266px;
        height: 63px;
    }

    ${mediaWidth.l} {
        width: 359px;
        height: 71px;
    }

    ${mediaWidth.xl} {
        width: 406px;
        height: 71px;
    }
`;

const ContentStyled = styled(Content)`
    position: relative;
`;

const Br = styled.br``;

export default StartScreenMain;
